// Contact page: form validation and submission
$(document).ready(function () {
	if (!$(".is-contact").length) {
		return;
	}

	var form = document.getElementById("contactForm");
	if (!form) {
		return;
	}

	function validateField(field) {
		var value = field.value.trim();
		var fieldName = field.name;
		var isValid = true;
		var errorMessage = "";

		if (field.hasAttribute("required") && !value) {
			isValid = false;
			errorMessage = "Trường này là bắt buộc";
		}

		if (fieldName === "email" && value) {
			if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
				isValid = false;
				errorMessage = "Email không hợp lệ";
			}
		}

		if (fieldName === "phone" && value) {
			if (!/^[0-9]{10,11}$/.test(value)) {
				isValid = false;
				errorMessage = "Số điện thoại phải có 10-11 chữ số";
			}
		}

		if (fieldName === "fullname" && value && value.length < 2) {
			isValid = false;
			errorMessage = "Họ tên phải có ít nhất 2 ký tự";
		}

		if (fieldName === "message" && value && value.length < 10) {
			isValid = false;
			errorMessage = "Tin nhắn phải có ít nhất 10 ký tự";
		}

		if (fieldName === "privacy" && !field.checked) {
			isValid = false;
			errorMessage = "Bạn phải đồng ý với điều khoản sử dụng";
		}

		var formGroup = field.closest(".form-group");
		if (formGroup) {
			if (isValid) {
				formGroup.classList.remove("error");
			} else {
				formGroup.classList.add("error");
			}

			var errorDiv = formGroup.querySelector(".form-error");
			if (errorDiv) {
				errorDiv.textContent = errorMessage;
			}
		}

		return isValid;
	}

	function clearFieldError(field) {
		var formGroup = field.closest(".form-group");
		if (formGroup) {
			formGroup.classList.remove("error");
			var errorDiv = formGroup.querySelector(".form-error");
			if (errorDiv) {
				errorDiv.textContent = "";
			}
		}
	}

	var inputs = form.querySelectorAll("input, textarea");
	inputs.forEach(function (input) {
		input.addEventListener("blur", function () {
			validateField(input);
		});
		input.addEventListener("input", function () {
			clearFieldError(input);
		});
	});

	form.addEventListener("submit", function (e) {
		e.preventDefault();
		var isFormValid = true;

		inputs.forEach(function (input) {
			if (!validateField(input)) {
				isFormValid = false;
			}
		});

		if (!isFormValid) {
			showNotification("Vui lòng kiểm tra lại thông tin", "error");
			return;
		}

		var submitBtn = form.querySelector(".btn");
		var btnText = submitBtn.querySelector(".btn-text");
		var btnLoading = submitBtn.querySelector(".btn-loading");

		if (btnText && btnLoading) {
			btnText.classList.add("d-none");
			btnLoading.classList.remove("d-none");
		}
		submitBtn.disabled = true;

		var formData = new FormData(form);

		setTimeout(function () {
			if (btnText && btnLoading) {
				btnText.classList.remove("d-none");
				btnLoading.classList.add("d-none");
			}
			submitBtn.disabled = false;
			showNotification(
				"Tin nhắn đã được gửi thành công! Chúng tôi sẽ liên hệ lại sớm nhất.",
				"success"
			);
			form.reset();
		}, 2000);
	});

	function showNotification(message, type) {
		var existing = document.querySelector(".contact-notification");
		if (existing) {
			existing.remove();
		}

		var iconClass =
			type === "success"
				? "fa-check-circle"
				: type === "error"
				? "fa-exclamation-circle"
				: "fa-info-circle";

		var notification = document.createElement("div");
		notification.className =
			"contact-notification contact-notification--" + type;
		notification.innerHTML =
			'<div class="notification-content"><i class="fas ' +
			iconClass +
			'"></i><span>' +
			message +
			"</span></div>";

		document.body.appendChild(notification);

		setTimeout(function () {
			notification.classList.add("contact-notification--visible");
		}, 100);

		setTimeout(function () {
			notification.classList.remove("contact-notification--visible");
			setTimeout(function () {
				if (notification.parentNode) {
					notification.parentNode.removeChild(notification);
				}
			}, 300);
		}, 5000);
	}
});
